import { ClassType } from "../../../types/Class";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { SubjectType } from "../../../types/Subject";
import { TeacherDepartamentType, TeacherDocumentType, TeacherType } from "../../../types/Teacher";
import { get } from "../../../utils/axios-config";
import { GET_TEACHER_BY_USER_ID, TEACHERS, TEACHERS_CLASSES, TEACHERS_DEPARTAMENTS, TEACHERS_DOCUMENTS, TEACHERS_SUBJECTS } from "../../../utils/constants";

export const getTeachers = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.idScientificArea ? { idScientificArea: data.idScientificArea } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),

    });
    const url = `${TEACHERS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherType>>(url)
};

export const getTeacherByUserId = async (id: string) => {
    const url = `${GET_TEACHER_BY_USER_ID}/${id}`;
    return await get<{idTeacher:string, idStudent?:string}>(url)
};


export const getTeacherSubjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),

    });
    const url = `${TEACHERS_SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<SubjectType>>(url)
};
export const getTeacherClasses = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
    });
    const url = `${TEACHERS_CLASSES}?${queryParams.toString()}`;
    return await get<PagedResultsType<ClassType>>(url)
};
export const getTeacherDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
    });
    const url = `${TEACHERS_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherDocumentType>>(url)
};
export const getTeacherDepartaments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
    });
    const url = `${TEACHERS_DEPARTAMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<TeacherDepartamentType>>(url)
};
